import React, {Component} from 'react';

class SystemUsageStatistics extends Component {

    constructor(props) {
        super(props);
        this.state = {
            vmData: this.props.vmData,
            ctData: this.props.ctData,
            loading: this.props.loading
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            vmData: nextProps.vmData,
            ctData: nextProps.ctData,
            loading: nextProps.loading
        });
    }

    render() {
        const vmData = this.state.vmData;
        const ctData = this.state.ctData;
        return (
            <div className="system-usage-statistics">
                <div className="system-usage-statistics-title">System Usage</div>
                <div>
                    <div className="system-usage-statistics-vm-number">{vmData.length}</div>
                    <div className="system-usage-statistics-vm-unit">Virtual Machines</div>
                </div>
                <div>
                    <div className="system-usage-statistics-ct-number">{ctData.length}</div>
                    <div className="system-usage-statistics-ct-unit">Containers</div>
                </div>
            </div>
        );
    }
}

export default SystemUsageStatistics;


// WEBPACK FOOTER //
// ./src/modules/dashboard/SystemUsageStatistics.js